import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import getStore from '../store/store';
import { default as createFolderId } from 'owa-service/lib/factory/folderId';

export default function getFullFolderId(folderIdOrName: string): string {
    let folderId = folderNameToId(folderIdOrName);
    if (!folderId) {
        // This is a non-distinguished folder
        folderId = folderIdOrName;
    }
    if (getStore().folderTable.get(folderId)) {
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2532 (15,16): Object is possibly 'undefined'.
        // @ts-expect-error
        return getStore().folderTable.get(folderId).id;
    }

    const createdFolderId = createFolderId({
        Id: folderId,
        __type: 'FolderId:#Exchange',
    });

    return createdFolderId.Id;
}
